module.exports = __webpack_public_path__ + "static/Mountain5-3badb9912daba0b0a4cbbb03c445950f.png";